import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { registerStaffWorker } from './lib/serviceWorker';
import './i18n';
import './index.css';
import './styles/tokens.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (window.isSecureContext && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void registerStaffWorker().catch(() => undefined);
  });
}
